/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Bwf_BadgeInputs */

const en_audio_description_export_bwf_badge = /** @type {(inputs: Audio_Description_Export_Bwf_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WAV Only`)
};

const fr_audio_description_export_bwf_badge = /** @type {(inputs: Audio_Description_Export_Bwf_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WAV uniquement`)
};

const de_audio_description_export_bwf_badge = /** @type {(inputs: Audio_Description_Export_Bwf_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur WAV`)
};

const it_audio_description_export_bwf_badge = /** @type {(inputs: Audio_Description_Export_Bwf_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo WAV`)
};

const ru_audio_description_export_bwf_badge = /** @type {(inputs: Audio_Description_Export_Bwf_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Только WAV`)
};

const es_audio_description_export_bwf_badge = /** @type {(inputs: Audio_Description_Export_Bwf_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sólo WAV`)
};

const zh_cn2_audio_description_export_bwf_badge = /** @type {(inputs: Audio_Description_Export_Bwf_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅限 WAV`)
};

const ja_audio_description_export_bwf_badge = /** @type {(inputs: Audio_Description_Export_Bwf_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WAVのみ`)
};

const hi_audio_description_export_bwf_badge = /** @type {(inputs: Audio_Description_Export_Bwf_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केवल WAV फ़ाइल`)
};

const pt_pt2_audio_description_export_bwf_badge = /** @type {(inputs: Audio_Description_Export_Bwf_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somente WAV`)
};

/**
* | output |
* | --- |
* | "WAV Only" |
*
* @param {Audio_Description_Export_Bwf_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_bwf_badge = /** @type {((inputs?: Audio_Description_Export_Bwf_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Bwf_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_bwf_badge(inputs)
	if (locale === "de") return de_audio_description_export_bwf_badge(inputs)
	if (locale === "it") return it_audio_description_export_bwf_badge(inputs)
	if (locale === "ru") return ru_audio_description_export_bwf_badge(inputs)
	if (locale === "es") return es_audio_description_export_bwf_badge(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_bwf_badge(inputs)
	if (locale === "ja") return ja_audio_description_export_bwf_badge(inputs)
	if (locale === "hi") return hi_audio_description_export_bwf_badge(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_bwf_badge(inputs)
	return en_audio_description_export_bwf_badge(inputs)
});